<template>
    <div>
        <vue-headful title="Inspection Import :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/inspections`">
                        <i class="fa fa-list"></i> Inspections
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Import a MeritEHS Generated Form Export
                </li>
            </ol>
        </h4>

        <div class="row">
            <div class="col-lg-7">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="alert alert-warning">
                            This Importer is only compatible with MeritEHS generated Form Export.<br/>These exports can be created from the <router-link to="/inspections/forms">Form Admin View</router-link>
                        </div>
                        <div class="row form-group">
                            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">File</label>
                            <div class="col-sm-8">

                                <b-form-file v-model="file" class="mt-3" plain accept=".xlsx" />
                                <span v-if="errors.file" class="text-danger">
                                    <span v-for="error in errors.file">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="button" class="btn btn-success" @click="importFile" :disabled="saving">
                            Import Inspection <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                        </button>

                        <b-form-checkbox v-model="import_more" :value="true" :unchecked-value="false" plain class="mt-3">
                            Import Another Inspection
                        </b-form-checkbox>
                    </div>
                </div>

                <div class="card" v-if="inspections.length > 0">
                    <div class="card-header">
                        Inspection Imported ({{ inspections.length }})
                    </div>
                    <div class="card-body">
                        <ul class="list-unstyled">
                            <li v-for="insp in inspections">
                                <router-link :to="`/inspections/view/${insp.InspectionId}`">
                                    INSP: {{ insp.InspectionId }}, {{ insp.InspectionDate | moment("MM/DD/YYYY") }} @ {{ insp.JobsiteNumber }} - {{ insp.JobsiteName }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: false,
                saving: false,
                import_more: false,
                file: null,
                errors: {},
                inspections: [],
            }
        },

        methods: {
            importFile() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setup payload
                var payload = {

                };

                //Send it
                this.$http
                .postWithSingleFile('inspections/import/offline', payload, this.file)
                .then(response => {
                    //Alert the user
                    this.$toastr.success('Inspections Imported');

                    //Check helper
                    if(this.import_more)
                    {
                        //Reset the form
                        this.file = null;

                        //Push it
                        this.inspections.push(response.data);
                    }
                    else
                    {
                        //Send it
                        this.$router.push('/inspections/view/'+response.data.InspectionId);
                    }

                    //Return to main list?
                    //this.$router.push('/inspections');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },
    }
</script>
